/**
 * One delivery time label of a variant, good up to a quantity. The last tier
 * has no limit. See AssortmentDeliveryTimes on the server.
 */
export interface DeliveryTimeTier {
  upToQuantity: number | null;
  label: string;
}

/**
 * The label of the first tier whose quantity covers the order, else the last
 * one. vallone-pro picks the same way.
 */
export const pickDeliveryTimeLabel = (deliveryTimes: DeliveryTimeTier[], quantity: number): string | null => {
  const tier = deliveryTimes.find((candidate) => candidate.upToQuantity === null || quantity <= candidate.upToQuantity) ?? deliveryTimes[deliveryTimes.length - 1];

  return tier?.label ?? null;
};
